import React from 'react';
import styles from './LoyaltyContainer.module.css';

export const LoyaltyContainer = ({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element => {
  return <div className={styles.container}>{children}</div>;
};
